import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import billing from './modules/billing'
import sipdevice from './modules/sipdevice'
import voicemail from './modules/voicemail'
import did from './modules/did'
import customer from './modules/customer'
import cdrs from './modules/cdr'
import ringgroup from './modules/ringgroup'
import callroute from './modules/callroute'
import ivr from './modules/ivr'
import queue from './modules/queue'
import timecondition from './modules/timecondition'
import callflow from './modules/callflow'
import musiconhold from './modules/musiconhold'
import systemrecording from './modules/systemrecording'
import contact from './modules/contact'
import bulletin from './modules/bulletin'

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';
const state = {};
const store = new Vuex.Store({
    state,
    modules: {
        auth: auth,
        did: did,
        sipdevice: sipdevice,
        billing: billing,
        customer: customer,
        voicemail: voicemail,
        cdrs: cdrs,
        ringgroup: ringgroup,
        callroute: callroute,
        ivr: ivr,
        queue: queue,
        timecondition: timecondition,
        callflow: callflow,
        musiconhold: musiconhold,
        systemrecording: systemrecording,
        contact: contact,
        bulletin: bulletin
    },
    strict: true,
});

if (module.hot) {
    // accept actions and mutations as hot modules
    module.hot.accept([], () => {
        store.hotUpdate({
            modules: {
                auth,
                did,
                sipdevice,
                billing,
                customer,
                voicemail,
                cdrs,
                ringgroup,
                callroute,
                ivr,
                queue,
                timecondition,
                callflow,
                musiconhold,
                systemrecording,
                contact,
                bulletin
            }
        })
    })
}

export default store
